module.exports = __webpack_public_path__ + "img/us_home_bg.fdacc8ed.jpg";